import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { InfoIcon } from 'lucide-react';
import type { InfoPopoverProps } from './InfoPopover.types';

/**
 * Info affordance for an identity block: a ghost icon button that opens a
 * popover of label/value rows. Not `PageHeaderInfoButton`, whose tooltip copy
 * is hardcoded to "About {{page}}" and doesn't fit an arbitrary info trigger.
 * All copy is resolved by the caller, so this component owns no i18n key.
 */
export function InfoPopover({ label, rows }: InfoPopoverProps) {
  return (
    <Popover>
      <TooltipProvider>
        <Tooltip>
          {/* The span keeps Tooltip and Popover off the same element: both write
              `data-state` on their trigger, and the later one wins. */}
          <TooltipTrigger asChild>
            <span className="inline-flex">
              <PopoverTrigger asChild>
                <Button variant="ghost" size="icon-sm" aria-label={label}>
                  <InfoIcon />
                </Button>
              </PopoverTrigger>
            </span>
          </TooltipTrigger>
          <TooltipContent>{label}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <PopoverContent className="flex flex-col gap-sm">
        {rows.map((row) => (
          <div key={row.label} className="flex flex-col gap-3xs">
            <span className="text-label-sm text-muted-foreground">{row.label}</span>
            <span className="text-body-sm">{row.value}</span>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}

InfoPopover.displayName = 'InfoPopover';
